import React from 'react';
import {
  FlexRow,
  Size,
  TableData,
  TableRow,
  useMatchMedia,
  TruncateBox,
} from '@make-software/cspr-design';
import { Tooltip, BodyText } from '@block-explorer/ui';
import { CopyButton } from '../../../components';
import NamedKeyValue from '../../../components/named-key-value/named-key-value';

interface AccountNamedKeysListItemProps {
  keyName: string;
  keyValue: string;
}

const AccountNamedKeysListItem = ({
  keyName,
  keyValue,
}: AccountNamedKeysListItemProps) => {
  const hashSize = useMatchMedia<Size>([1, 2, 2, 2], []);

  return (
    <TableRow>
      <TableData>
        <FlexRow align={'center'}>
          <>
            <TruncateBox size={hashSize}>
              <Tooltip tooltipContent={keyValue}>
                <BodyText size={3} noWrap>
                  {keyValue}
                </BodyText>
              </Tooltip>
            </TruncateBox>
            <CopyButton value={keyValue} />
          </>
        </FlexRow>
      </TableData>
      <TableData>
        <FlexRow itemsSpacing={4} align="center">
          <BodyText size={3} monotype noWrap>
            <NamedKeyValue namedKey={keyName} />
          </BodyText>
          <CopyButton value={keyName} />
        </FlexRow>
      </TableData>
    </TableRow>
  );
};

export default AccountNamedKeysListItem;
